'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var appTypes = require('../../types/appTypes');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var graphicsHelper = require('./../../helper/graphicsHelper.js');
var _ = require('underscore');
var util = require('../../helper/util');

/**
 * Gif组件
 * @author Allen
 * @createDate 2017/7/13
 **/

var Triangle = React.createClass({

  componentDidMount: function() {
    this.paint(this.props);
  },

  componentDidUpdate: function() {
    this.paint(this.props);
  },

  render: function () {
    var shapeStyle = {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      boxSizing: 'border-box'
    };

    shapeStyle.zIndex = -1;
    return (
        <canvas
            ref="canvas"
            style={shapeStyle}
            onChange={this.paint.bind(this, this.props)}
            width={styleHelper.getWidth(this.props)}
            height={styleHelper.getHeight(this.props)}/>
    );
  },


  paint: function (props) {
    var color = styleHelper.getBackgroundColor(this.props);
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
    var ctx = canvas.getContext('2d');
    graphicsHelper.drawTriangle(ctx,
        {
          width: w,
          height: h,
          dashMode: dashMode,
          borderType: appTypes.ShapeType.TRIANGLE,
          borderVisible: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE),
          borderColor: styleHelper.getBorderColor(this.props),
          fillColor: color,
          borderWidth: styleHelper.getBorderWidth(this.props),
          triangleType: styleHelper.getPropertyValue(this.props, 'triangleType'),
          triangleDirection: styleHelper.getPropertyValue(this.props, 'triangleDirection')
        });
  },


});

module.exports = Triangle;


// WEBPACK FOOTER //
// ./src/views/Components/Triangle.jsx